import { NAME } from './constants';

export const FETCH_USERS = `${NAME}/FETCH_USERS`;
export const FETCH_USERS_FAILURE = `${NAME}/FETCH_USERS_FAILURE`;
export const FETCH_USERS_SUCCESS = `${NAME}/FETCH_USERS_SUCCESS`;

export const FETCH_PHONE_CODES = `${NAME}/FETCH_PHONE_CODES`;
export const FETCH_PHONE_CODES_FAILURE = `${NAME}/FETCH_PHONE_CODES_FAILURE`;
export const FETCH_PHONE_CODES_SUCCESS = `${NAME}/FETCH_PHONE_CODES_SUCCESS`;

export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;

export const OPEN_DUPLICATE_MODAL = `${NAME}/OPEN_DUPLICATE_MODAL`;

export const RESET = `${NAME}/RESET`;
export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE_CONTACT = `${NAME}/SAVE_CONTACT`;
export const SAVE_CONTACT_FAILURE = `${NAME}/SAVE_CONTACT_FAILURE`;
export const SAVE_CONTACT_SUCCESS = `${NAME}/SAVE_CONTACT_SUCCESS`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;

export const SHOW_MODAL = `${NAME}/SHOW_MODAL`;
